module.exports = __webpack_public_path__ + "media/images/home-page-new-banner-93f667e1c359ff8b47f92cf17ffde878.jpg";